import { MarkAsDiscrepantToggle } from './MarkAsDiscrepantToggle';
import { useMarkAsDiscrepant } from 'hooks/useMarkAsDiscrepant';
import { CriticalResultsToggle } from './CriticalResultsToggle';
import { useCriticalResults } from 'domains/worklist/Worklist/hooks/useCriticalResults';
import { Stack } from 'common/ui/Layout';
import { telemetryContextFor } from 'modules/Apollo/types';
import { ReportStatus, reportStatusState } from '../state';
import type { ReportStatuses } from '../state';
import { useRecoilValue } from 'recoil';

export const FieldsSubmitToggleRow = () => {
  const { hasAccessToCriticalWorkflow } = useCriticalResults({ context: APOLLO_QUERY_CONTEXT });
  const {
    shouldRenderMarkAsDiscrepantToggle,
    toggleMarkAsDiscrepant,
    isDiscrepancyFlagged,
    isDisabled,
  } = useMarkAsDiscrepant({ context: APOLLO_QUERY_CONTEXT });
  const status = useRecoilValue(reportStatusState);

  return (
    <Stack alignX="end" alignY="center" space="small">
      {shouldRenderMarkAsDiscrepantToggle && (
        <MarkAsDiscrepantToggle
          hasDiscrepantResult={isDiscrepancyFlagged}
          onToggle={(_, checked) => toggleMarkAsDiscrepant(checked)}
          isDisabled={isDisabled}
        />
      )}
      {hasAccessToCriticalWorkflow && (
        <CriticalResultsToggle
          isDisabled={(
            [
              ReportStatus.ProvisionalAddendumSubmit,
              ReportStatus.ProvisionalPrelimSubmit,
              ReportStatus.ProvisionalSubmit,
            ] as ReportStatuses[]
          ).includes(status)}
        />
      )}
    </Stack>
  );
};

FieldsSubmitToggleRow.displayName = 'FieldsSubmitToggleRow';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(FieldsSubmitToggleRow);
